import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Root from "./pages/root";
import { Provider } from "react-redux";
import store from "./store";

const render = element => {
    const el =
        element instanceof HTMLElement
            ? element
            : document.querySelector(element);

    ReactDOM.render(
        <Provider store={store}>
            <Root />
        </Provider>,
        el
    );
};

window._smuEmbedCommunityProjects = render;

if (module.hot) {
    module.hot.accept("./pages/root", function() {
        render("#root");
    });
}



// WEBPACK FOOTER //
// ./src/index.js